import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LocalizationDictionary, LocalizationService } from '../../_jovdk-web/features/localization-service/localization-service.service';
import { ExternalUrlResolverService } from '../../_jovdk-web/features/url-resolver/external-url-resolver.service';

interface FooterLink {
    labelKey: string;
    href: string;
    external?: boolean;
    resolvedHref?: string;
}

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [
        NgFor,
        RouterLink,
    ],
    templateUrl: './footer.component.html',
})
export class FooterComponent {
    protected readonly _localizationService = inject(LocalizationService);
    private _externalUrlResolver = inject(ExternalUrlResolverService);
    private _cdr = inject(ChangeDetectorRef);

    readonly exploreChainHref = this.ResolveExternal('https://scan.hbariot.com');
    terms: LocalizationDictionary = {};

    navLinks: FooterLink[] = [
        { labelKey: 'footer-nav-home', href: '/' },
        { labelKey: 'footer-nav-downloads', href: '/downloads' },
        { labelKey: 'footer-nav-nodes', href: '/nodes' },
        { labelKey: 'footer-nav-requirements', href: '/requirements' },
        { labelKey: 'footer-nav-docs', href: '/docs' },
    ];

    externalLinks: FooterLink[] = [
        {
            labelKey: 'footer-explore-chain',
            href: 'https://scan.hbariot.com',
            resolvedHref: this.exploreChainHref,
            external: true,
        },
        {
            labelKey: 'footer-links-twitter',
            href: 'https://x.com/0xhbariot',
            resolvedHref: this.ResolveExternal('https://x.com/0xhbariot'),
            external: true,
        },
        {
            labelKey: 'footer-links-github',
            href: 'https://github.com/HBARiot',
            resolvedHref: this.ResolveExternal('https://github.com/HBARiot'),
            external: true,
        },
        {
            labelKey: 'footer-links-discord',
            href: 'https://discord.gg/',
            resolvedHref: this.ResolveExternal('https://discord.gg/'),
            external: true,
        },
    ];

    private ResolveExternal(url: string)
    {
        return this._externalUrlResolver.Resolve(url);
    }

    constructor()
    {
        this._localizationService.Terms$
            .pipe(takeUntilDestroyed())
            .subscribe((dictionary) =>
            {
                this.terms = dictionary;
                this._cdr.markForCheck();
            });
    }
}
